import { RelatedProductsAccordion } from 'components/Product';
import { PRODUCT_DETAILS_SPARE_PARTS_ID } from 'constants/ids';
import type { VariantId } from 'models/product';

import { useSparePartsContext } from '../ProductDetailsContext';

interface Props {
	contentClassName: string;
	expiredProductsTitle: string;
	loadMoreButtonText: string;
	noProductsText: string;
	title: string;
	variantId: VariantId;
}

export default function SparePartsAccordion({
	contentClassName,
	expiredProductsTitle,
	loadMoreButtonText,
	noProductsText,
	title,
	variantId,
}: Props) {
	const {
		hasNextPage,
		isLoading,
		isLoadingMore,
		isOpen,
		items,
		loadMore,
		toggleOpen,
	} = useSparePartsContext();
	return (
		<RelatedProductsAccordion
			accordionId={PRODUCT_DETAILS_SPARE_PARTS_ID}
			expiredProductsTitle={expiredProductsTitle}
			loadMoreButtonText={loadMoreButtonText}
			title={title}
			gtmItemListId="pdp_spare_parts"
			gtmItemListName={`List: Spare parts ${variantId}`}
			noProductsText={noProductsText}
			products={items}
			isLoadingInitial={isLoading}
			isLoadingMore={isLoadingMore}
			hasNextPage={hasNextPage}
			onLoadMoreClick={loadMore}
			contentClassName={contentClassName}
			isOpen={isOpen}
			onClick={toggleOpen}
		/>
	);
}

SparePartsAccordion.displayName = 'SparePartsAccordion';
